'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CreditCardAppIcon = function CreditCardAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 500 500",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    id: "Credit-Card-B"
  }, React__default["default"].createElement("g", {
    id: "Group-Copy",
    transform: "translate(248.000000, 223.500000) rotate(-15.000000) translate(-248.000000, -223.500000) translate(23.000000, 75.000000)"
  }, React__default["default"].createElement("rect", {
    id: "Rectangle-4",
    fill: "#EEEEEE",
    x: "0",
    y: "0",
    width: "450",
    height: "297",
    rx: "40"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-5",
    fill: "#9E9E9E",
    x: "0",
    y: "50",
    width: "450",
    height: "55"
  })), React__default["default"].createElement("rect", {
    id: "Rectangle-4",
    fill: "#1E88E5",
    x: "48",
    y: "150",
    width: "450",
    height: "297",
    rx: "40"
  }), React__default["default"].createElement("path", {
    d: "M88,150 L458,150 C480.09139,150 498,167.90861 498,190 L498,407 C498,429.09139 480.09139,447 458,447",
    id: "Rectangle-4-Copy",
    fill: "#1976D2"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "78",
    y: "255",
    width: "90",
    height: "67",
    rx: "5"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "78",
    y: "352",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "178",
    y: "352",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "278",
    y: "352",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-6-Copy",
    fill: "#EEEEEE",
    points: "340 352 368 352 368 375"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#EEEEEE",
    x: "378",
    y: "352",
    width: "90",
    height: "25"
  }))));
};

var CreditCardAppIcon$1 = iconStyles()(CreditCardAppIcon);

module.exports = CreditCardAppIcon$1;
